import { slugToMatch } from "@/utils/slug";

export const defaultSeo = {
  title:
    "Home Services in Kochi & Kerala | Cleaning, AC Repair, Plumbing & Electrician - Oh Yes",
  description:
    "Book trusted home services in Kerala, Kochi and Bangalore with Oh Yes Home Solutions. Expert cleaning, AC service, plumbing, electrical and appliance repair at affordable prices.",
};

export const pageSeo = {
  about: {
    title: "Oh Yes About Us | Expert Home Services Across Kerala",
    description:
      "Oh Yes offers trusted and affordable home service across Kerala. Discover our mission, expert team, and commitment to quality service for every home.",
  },
  services: {
    title: "Oh Yes Services - Trusted Home Service Experts",
    description:
      "Explore Oh Yes World services including AC repair, cleaning, plumbing, electrical, and more. Book trusted experts online for fast and reliable home services.",
  },
  blog: {
    title: "Oh Yes Blog - Home Service Tips & Expert Guides",
    description:
      "Read the Oh Yes blog for home service tips, maintenance guides, and expert advice on AC, cleaning, plumbing, and electrical services. Stay informed.",
  },
  news: {
    title: "Latest News & Updates | Oh Yes Home Services",
    description:
      "Stay updated with the latest news, service updates, offers, and announcements from Oh Yes World. Explore trends in home services.",
  },
};

const serviceSeoItems = [
  {
    keywords: ["ac", "air-conditioner", "air conditioner"],
    title: "Oh Yes AC Service - Fast and Trusted Professionals",
    description:
      "Book fast and trusted AC service with Oh Yes World. Expert AC repair, installation, and maintenance by skilled technicians. Easy online booking and reliable support.",
  },
  {
    keywords: ["cleaning", "deep-cleaning", "deep cleaning"],
    title: "Oh Yes Cleaning Service - Safe & Trusted Expert",
    description:
      "Get safe and trusted cleaning services with Oh Yes World. Home, office, and deep cleaning by professional experts. Book online easily for a clean and healthy space.",
  },
  {
    keywords: ["plumbing", "plumber"],
    title: "Oh Yes Plumbing Service",
    description:
      "Oh Yes World provides reliable plumbing services including pipe repair, leak fixing, and installation. Book trusted plumbers online for quick and hassle-free service.",
  },
  {
    keywords: ["electrical", "electrician", "electric"],
    title: "Oh Yes Electrical Services - Quick & Trusted Help",
    description:
      "Oh Yes offers quick and trusted electrical services including wiring, repair, and installation. Book certified electricians online for safe and reliable service.",
  },
  {
    keywords: ["appliance", "washing-machine", "fridge", "refrigerator"],
    title: "Oh Yes Appliance Repair - Expert Repairing & Services",
    description:
      "Get expert appliance repair services with Oh Yes. Washing machine, fridge, and home appliance repair by trusted technicians. Book service easily online.",
  },
  {
    keywords: ["painting", "painter"],
    title: "Oh Yes Painting Service - Professional Painters",
    description:
      "Oh Yes painting services provide professional home and office painting with skilled painters. Book trusted painting experts for quality and clean finishing.",
  },
  {
    keywords: ["interior", "interiors", "designer", "designers"],
    title: "Oh Yes Interior - Trusted Home Designers",
    description:
      "Get trusted interior design services from Oh Yes. Expert home designers create modern, stylish, and functional living spaces. Book interior services online today.",
  },
  {
    keywords: ["garden", "gardening", "landscaping", "lawn"],
    title: "Oh Yes Garden Services - Garden Design Expert",
    description:
      "Oh Yes provides trusted garden services with expert lawn care, landscaping, and garden design. Book professional gardeners for a beautiful outdoor space.",
  },
  {
    keywords: ["construction", "builder", "builders", "home-builder"],
    title: "Oh Yes Construction Service - Build Your Dream Home",
    description:
      "Oh Yes World offers trusted construction services with expert builders, quality materials, and professional planning to deliver strong and modern dream homes.",
  },
  {
    keywords: ["water-purifier", "water purifier", "ro"],
    title: "Oh Yes Water Purifier",
    description:
      "Book trusted water purifier services with Oh Yes. Expert RO repair, installation, and maintenance to ensure clean and safe drinking water at home or anywhere.",
  },
];

function normalize(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[_/]+/g, "-")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export function getServiceSeo(value) {
  const normalized = normalize(slugToMatch(decodeURIComponent(value || "")));

  return (
    serviceSeoItems.find((item) =>
      item.keywords.some((keyword) => normalized.includes(normalize(keyword))),
    ) || null
  );
}

export function resolveSeo(to) {
  const metaSeo =
    typeof to.meta?.seo === "function" ? to.meta.seo(to) : to.meta?.seo;

  if (metaSeo) {
    return metaSeo;
  }

  return defaultSeo;
}

